import { Button, Divider, Flex } from "@aws-amplify/ui-react";
import { Auth } from "aws-amplify";
import { FormInput } from "components/form";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import "../authenticator-components.css";

export type FederatedProvider = {
  email_domains: string[];
  provider_name: string;
};

type CustomSSOFormProps = {
  ssoProviders: FederatedProvider[];
};

const CustomSSOForm = ({ ssoProviders }: CustomSSOFormProps) => {
  const { pathname } = useLocation();
  const [email, setEmail] = useState("");
  const emailSplit = email.split("@");
  const emailDomain = emailSplit.length === 2 ? emailSplit[1] : null;
  const activeProvider = ssoProviders.find(
    provider => emailDomain && provider.email_domains.includes(emailDomain)
  );

  const signInWithSSO = () => {
    if (activeProvider) {
      Auth.federatedSignIn({
        customProvider: activeProvider.provider_name,
        customState: pathname
      });
    }
  };

  return (
    <Flex
      as="form"
      padding={`0 32px`}
      direction={"column"}
      onSubmit={event => {
        event.preventDefault();
        signInWithSSO();
      }}
    >
      <FormInput
        data-testid="sso-email-input"
        type="email"
        name="Email Address"
        autoComplete="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <Button
        backgroundColor={activeProvider ? undefined : "grey"}
        className="sso-button"
        data-testid="sso-button"
        disabled={!activeProvider}
        type="submit"
        title={
          !activeProvider
            ? email.includes("@")
              ? "The email address does not have an SSO provider registered"
              : "Enter your email address to enable SSO sign in"
            : undefined
        }
      >
        Sign in with SSO
      </Button>
      <Divider label="or" />
    </Flex>
  );
};
export default CustomSSOForm;
